import React from "react";
import { Link } from "@quintype/components";
import { object, bool, string } from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";

import "./storytitleInfo.m.css";

const StoryTitleInfo = ({ story, iconLiveBlog, summary, publisherAttributes }) => {
  const isClosed = get(story, ["metadata", "is-closed"], false);
  const sectionName = get(story, ["sections", "0"], "");
  const getSubjectTopicTag = () => {
    if (!publisherAttributes.subject_topic_linked_entity) {
      const subjectTopicTag =
        story.tags && story.tags.length > 0 ? story.tags.find((tag) => tag.type === "subject-topic-tag") : null;
      return subjectTopicTag;
    }

    const subjectTopicAttributeId = get(story, ["metadata", "story-attributes", "subjecttopic", "0", "id"], null);
    const subjectTopicLinkedEntity =
      story["linked-entities"] && story["linked-entities"].length > 0 && subjectTopicAttributeId
        ? story["linked-entities"].find((item) => item.id === subjectTopicAttributeId)
        : null;
    return subjectTopicLinkedEntity;
  };

  return (
    <div styleName="wrapper" className="story-title-info">
      {iconLiveBlog && !isClosed && <span styleName="live-text" />}
      <div
        styleName={`entity-section-wrapper ${
          getSubjectTopicTag() && getSubjectTopicTag().name.length > 15 ? "long-section-wrapper" : ""
        }`}
        className="print-entity-section-wrapper"
      >
        {sectionName && (
          <Link aria-label={sectionName["display-name"]} href={sectionName["section-url"]} styleName="sub-section-name">
            {sectionName["display-name"]}
          </Link>
        )}
        {getSubjectTopicTag() && (
          <Link
            aria-label={getSubjectTopicTag().name}
            href={"/topic/" + getSubjectTopicTag().slug}
            className="topic-tag"
          >
            {getSubjectTopicTag().name}
          </Link>
        )}
      </div>
      {story.subheadline && (
        <div styleName="sub-headline-entity-section-wrapper" className="print-entity-section-wrapper">
          <h2 styleName="sub-headline">{story.subheadline} </h2>
        </div>
      )}
      <div>
        <h1 styleName="story-headline ">{story.headline}</h1>
      </div>
      {summary && <div dangerouslySetInnerHTML={{ __html: summary }} styleName="summary" />}
    </div>
  );
};

StoryTitleInfo.propTypes = {
  story: object.isRequired,
  iconLiveBlog: bool,
  summary: string,
  publisherAttributes: object,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

export default connect(mapStateToProps, null)(StoryTitleInfo);
